// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1519":"efd6b2c2","4777":"907df523"}[chunkId] + ".chunk.css";
};